/* eslint-disable no-shadow, no-unused-vars */
enum OutsideRamqBillingManager {
  MEDYX = 'medyx',
  DOCTOR = 'doctor'
}

export default OutsideRamqBillingManager;
